import React, {CSSProperties} from 'react';
import clsx from 'clsx';

import styles from './Loading.module.css';

interface LoadingProps {
  size?: string,
  color?: string
  className?: string
}


const Loading = ({size = '64px', color, className}: LoadingProps) => {

  const customStyles = {
    '--size': size,
    ...(color ? {'--loading-color': color} : {})
  };

  return (
    <div className={styles.root}>
      <div className={clsx(styles['lds-ring'], className)} style={customStyles as CSSProperties} data-manabie="loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
};

export default Loading